'use strict';

var _createForOfIteratorHelper = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var Container = require('./container');

var LazyResult, Processor;

var Root = /*#__PURE__*/function (_Container) {
  _inherits(Root, _Container);

  var _super = _createSuper(Root);

  function Root(defaults) {
    var _this;

    _classCallCheck(this, Root);

    _this = _super.call(this, defaults);
    _this.type = 'root';
    if (!_this.nodes) _this.nodes = [];
    return _this;
  }

  _createClass(Root, [{
    key: "removeChild",
    value: function removeChild(child, ignore) {
      var index = this.index(child);

      if (!ignore && index === 0 && this.nodes.length > 1) {
        this.nodes[1].raws.before = this.nodes[index].raws.before;
      }

      return _get(_getPrototypeOf(Root.prototype), "removeChild", this).call(this, child);
    }
  }, {
    key: "normalize",
    value: function normalize(child, sample, type) {
      var nodes = _get(_getPrototypeOf(Root.prototype), "normalize", this).call(this, child);

      if (sample) {
        if (type === 'prepend') {
          if (this.nodes.length > 1) {
            sample.raws.before = this.nodes[1].raws.before;
          } else {
            delete sample.raws.before;
          }
        } else if (this.first !== sample) {
          var _iterator = _createForOfIteratorHelper(nodes),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var node = _step.value;
              node.raws.before = sample.raws.before;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }

      return nodes;
    }
  }, {
    key: "toResult",
    value: function toResult() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var lazy = new LazyResult(new Processor(), this, opts);
      return lazy.stringify();
    }
  }]);

  return Root;
}(Container);

Root.registerLazyResult = function (dependant) {
  LazyResult = dependant;
};

Root.registerProcessor = function (dependant) {
  Processor = dependant;
};

module.exports = Root;
Root["default"] = Root;